export default "//cdn.scentbird.com/assets/frontbird-site/images/mobile_79b595.gif";